import angular from 'angular';

// Use Vite's import.meta.glob instead of bulk-require
const modules = import.meta.glob(['./**/*.js', '!./index.js', '!./**/*.spec.js'], { eager: true });

const controllersModule = angular.module('app.controllers', []);

function declare(mod) {
  if (!mod) return;
  
  // Handle both default exports and named exports
  const item = mod.default || mod;
  
  if (item.fn && typeof item.fn === 'function') {
    controllersModule.controller(item.name, item.fn);
  }
}

Object.values(modules).forEach(declare);

export default controllersModule;
